import React from 'react';
import { Svg } from '../../1_Atoms/Svg/Svg';
import { closeModal } from '../../../utils/helpers';

interface ModalProps {
  className?: string;
  id?: string;
  isOpen?: boolean;
  isDark?: boolean;
  children?: React.ReactNode;
  onClose?: () => void;
  modalRef?: React.RefObject<HTMLDivElement>;
}

const Modal: React.FC<ModalProps> = ({
  className = '',
  id = '',
  isOpen = false,
  isDark = false,
  children,
  onClose,
  modalRef,
  ...otherProps
}) => {
  return (
    <div
      id={id}
      className={`mz-modal mz-react-form-modal ${className}`}
      aria-hidden={!isOpen}
      ref={modalRef}
      {...otherProps}
    >
      <div className="mz-modal__inner mz-container">
        <div className="mz-modal__wrapper mz-full-width">
          <div className="mz-modal__close">
            <button
              className="mz-modal-close-button reset"
              aria-label="Close Modal"
              onClick={() => {
                if (modalRef && modalRef.current) {
                  closeModal(modalRef.current);
                }
                if (onClose) {
                  onClose();
                }
              }}
            >
              <Svg
                type="x"
                size={1.875}
                colour={isDark ? 'white' : 'grey'}
              />
            </button>
          </div>
          <div className="mz-modal__content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
